import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { computed } from 'vue'

interface Props {
  loadMoreCallback?: () => void
  loadMoreLoading?: boolean
  loadMoreHasMore?: boolean
  loadMoreDisabled?: boolean
  loadMoreThreshold?: number
  loadMoreDelay?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'content-adapt-layout',
  props: {
    loadMoreCallback: { type: Function, default: undefined },
    loadMoreLoading: { type: Boolean, default: false },
    loadMoreHasMore: { type: Boolean, default: true },
    loadMoreDisabled: { type: Boolean, default: false },
    loadMoreThreshold: { default: 10 },
    loadMoreDelay: { default: 100 }
  },
  emits: ['loadMore'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const loadMoreConfig = computed(() => {
  try {
    // 确保所有值都有默认值
    const hasMore = typeof props.loadMoreHasMore === 'boolean' ? props.loadMoreHasMore : false
    const loading = typeof props.loadMoreLoading === 'boolean' ? props.loadMoreLoading : false
    const threshold = typeof props.loadMoreThreshold === 'number' ? props.loadMoreThreshold : 10
    const delay = typeof props.loadMoreDelay === 'number' ? props.loadMoreDelay : 100

    // 如果没有提供 callback，使用事件方式（向后兼容）
    const callback = typeof props.loadMoreCallback === 'function' ? props.loadMoreCallback : (() => emit('loadMore'))

    return {
      callback: callback,
      loading: loading,
      hasMore: hasMore,
      disabled: props.loadMoreDisabled || !hasMore || loading,
      threshold: threshold,
      delay: delay
    }
  } catch (error) {
    // 如果出现任何错误，返回一个安全的默认配置
    return {
      callback: () => {},
      loading: false,
      hasMore: false,
      disabled: true,
      threshold: 10,
      delay: 100
    }
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_main = _resolveComponent("el-main")!
  const _directive_load_more = _resolveDirective("load-more")!

  return (_openBlock(), _createBlock(_component_el_main, { class: "wrap" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, {
        class: "header",
        height: "auto"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "header")
        ]),
        _: 3
      }),
      _withDirectives((_openBlock(), _createBlock(_component_el_container, {
        class: "soft-container",
        direction: "vertical"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })), [
        [_directive_load_more, loadMoreConfig.value]
      ]),
      _createVNode(_component_el_footer, {
        class: "footer",
        height: "auto"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "footer")
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})